import { render } from "./GrafmonumentenView.vue?vue&type=template&id=a23d91f4"
import script from "./GrafmonumentenView.vue?vue&type=script&lang=js"
export * from "./GrafmonumentenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__